
/**
 * A small tag indicating something is only for premium members.
 */
export default {
  name: 'PremiumOnlyTag',
  components: {},
  computed: {},
};
